import { render, staticRenderFns } from "./ScheduleBoardMonthView.vue?vue&type=template&id=1088ac2c"
import script from "./ScheduleBoardMonthView.vue?vue&type=script&lang=js"
export * from "./ScheduleBoardMonthView.vue?vue&type=script&lang=js"
import style0 from "./ScheduleBoardMonthView.vue?vue&type=style&index=0&id=1088ac2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports